import React, { Component } from 'react'
import { Collapse, Container, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap'
import { Link } from 'react-router-dom'
import 'font-awesome/css/font-awesome.css'
import { connect } from 'react-redux'
import { updateRedirect } from '../helpers/redirect'
import { getPermission } from '../api/userapi'
import { PageViewUpdate } from './tracking/tracking'

class Navigation extends Component {
    constructor(props) {
        super(props)
        this.permission = getPermission()
        this.toggle = this.toggle.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.state = {
            isOpen: false,
            selected: '',
            selectedAdmin: '',
            toggleAdminDropdown: false,
        }
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
        })

        this.props.sendData(!this.state.isOpen)
    }

    handleClick() {
        this.setState({
            toggleAdminDropdown: !this.state.toggleAdminDropdown,
        })
    }

    getLocation() {
        let selected

        function winLocation(term) {
            return window.location.pathname.includes(term)
        }

        switch (true) {
            case winLocation('gift'):
                selected = 'gifts'
                break
            case winLocation('sale'):
                selected = 'sales'
                break
            case winLocation('product'):
                selected = 'products'
                break
            case winLocation('promoCode'):
                selected = 'promoCodes'
                break
            case winLocation('location'):
                selected = 'cities'
                break
            case winLocation('branch'):
                selected = 'branches'
                break
            case winLocation('user'):
                selected = 'users'
                break
            case winLocation('club'):
                selected = 'clubs'
                break
            case winLocation('enrollment'):
                selected = 'admin'
                break
            case winLocation('redemptionCodes'):
                selected = 'redemptionCodes'
                break
            default:
                selected = ''
        }
        let pathNoIds = window.location.pathname.replace(/\d+/g, '')
        if (pathNoIds.includes('//')) {
            pathNoIds = pathNoIds.substring(0, pathNoIds.length - 1)
        }

        PageViewUpdate(pathNoIds)
        return selected
    }

    componentDidMount() {
        const location = this.getLocation()

        if (location) {
            const prev = document.getElementsByClassName('selected')

            for (const p of prev) {
                p.classList.remove('selected')
            }
            if (this.props.currentNavigationSelect !== null) {
                const currentState = {
                    isOpen: this.props.currentNavigationSelect.isOpen,
                    selected: this.props.currentNavigationSelect.selected,
                    selectedAdmin: this.props.currentNavigationSelect.selectedAdmin,
                    toggleAdminDropdown: this.props.currentNavigationSelect.toggleAdminDropdown,
                }
                this.setState(currentState)
                this.props.currentNavigationConnect(null)
            }
            if (location === 'admin') {
                document.getElementById('main-menu-chevron-down').style.opacity = '1'
                document.getElementById('admin').style.borderBottom = '3px solid #2BA848'
                this.handleClick()
                if (window.location.pathname.includes('club')) {
                    this.setState({ selectedAdmin: 'clubs' })
                } else if (window.location.pathname.includes('enrollment')) {
                    this.setState({ selectedAdmin: 'enrollment' })
                } else {
                    this.setState({ selectedAdmin: 'users' })
                }
            } else {
                const selected = document.getElementById(location)
                selected.classList.add('selected')
                selected.firstElementChild.classList.add('selected')
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let currentState = this.state
        let originOther = false
        if (this.props.currentNavigationSelect !== null && prevProps.currentNavigationSelect === null) {
            currentState = {
                isOpen: this.props.currentNavigationSelect.isOpen,
                selected: this.props.currentNavigationSelect.selected,
                selectedAdmin: this.props.currentNavigationSelect.selectedAdmin,
                toggleAdminDropdown: this.props.currentNavigationSelect.toggleAdminDropdown,
            }
            this.setState(currentState)
            this.props.currentNavigationConnect(null)
            originOther = true
        }

        if (prevState.selected !== currentState.selected) {
            const prev = document.getElementsByClassName('main-menu nav-link')
            for (const p of prev) {
                p.classList.remove('selected')
            }
            const prev2 = document.getElementsByClassName('main-menu nav-item')
            for (const p2 of prev2) {
                p2.classList.remove('selected')
            }

            if (prevState.selected === 'admin') {
                document.getElementById('main-menu-chevron-down').style.opacity = '0.6'
                document.getElementById('admin').style.borderBottom = ''
                this.handleClick()
            }

            if (currentState.selected === 'admin') {
                document.getElementById('main-menu-chevron-down').style.opacity = '1'
                document.getElementById('admin').style.borderBottom = '3px solid #2BA848'
                if (
                    !originOther &&
                    (prevProps.currentNavigationSelect === null ||
                        prevProps.currentNavigationSelect.selected !== 'admin') &&
                    !prevState.toggleAdminDropdown
                ) {
                    this.handleClick()
                }

                if (document.getElementById(currentState.selectedAdmin)) {
                    document.getElementById(currentState.selectedAdmin).classList.add('selected')
                }
            } else {
                const selected = document.getElementById(currentState.selected)
                if (selected) {
                    selected.classList.add('selected')
                    selected.firstElementChild.classList.add('selected')
                }
            }
        } else if (currentState.selected === 'admin' && prevState.selectedAdmin != '') {
            const prevAdmin = document.getElementById(prevState.selectedAdmin)
            if (prevAdmin !== null && prevState.selectedAdmin !== currentState.selectedAdmin) {
                prevAdmin.classList.remove('selected')
            }
        }

        if (
            prevState.selectedAdmin !== currentState.selectedAdmin &&
            currentState.selectedAdmin !== ''
        ) {
            document.getElementById(currentState.selectedAdmin).classList.add('selected')
        }
    }

    render() {
        let { toggleAdminDropdown } = this.state
        let { isOpen } = this.state
        if (this.props.currentNavigationSelect !== null) {
            toggleAdminDropdown = this.props.currentNavigationSelect.toggleAdminDropdown
            isOpen = this.props.currentNavigationSelect.isOpen
        }

        return (
            <Navbar className="navbar navbar-expand-lg navbar-light bg-light main-menu" light>
                <Container className="main-menu">
                    <NavbarToggler onClick={this.toggle} className="mr-2" />
                    <Collapse
                        className="collapse flex-column navbar-collapse main-menu"
                        isOpen={isOpen}
                        navbar
                    >
                        <ul className="border-bottom flex-grow navbar-nav main-menu">
                            <NavItem className="main-menu" id="gifts">
                                <NavLink
                                    tag={Link}
                                    className="main-menu"
                                    to="/secure/gifts"
                                    onClick={() => this.setState({ selected: 'gifts', selectedAdmin: '' })}
                                >
                                    GIFTS
                                </NavLink>
                            </NavItem>
                            <NavItem className="main-menu" id="sales">
                                <NavLink
                                    tag={Link}
                                    className="main-menu"
                                    to="/secure/sales"
                                    onClick={() => this.setState({ selected: 'sales', selectedAdmin: '' })}
                                >
                                    SALES
                                </NavLink>
                            </NavItem>
                            <NavItem className="main-menu" id="products">
                                <NavLink
                                    tag={Link}
                                    className="main-menu"
                                    to="/secure/products"
                                    onClick={() => this.setState({ selected: 'products', selectedAdmin: '' })}
                                >
                                    PRODUCTS
                                </NavLink>
                            </NavItem>
                            <NavItem className="main-menu" id="promoCodes">
                                <NavLink
                                    tag={Link}
                                    className="main-menu text-nowrap"
                                    to="/secure/promoCodes"
                                    onClick={() => this.setState({ selected: 'promoCodes', selectedAdmin: '' })}
                                >
                                    PROMO CODES
                                </NavLink>
                            </NavItem>
                            {/*<NavItem className="main-menu" id="redemptionCodes">*/}
                            {/*    <NavLink*/}
                            {/*        tag={Link}*/}
                            {/*        className="main-menu  text-nowrap"*/}
                            {/*        to="/secure/redemptionCodes"*/}
                            {/*        onClick={() =>*/}
                            {/*            this.setState({*/}
                            {/*                selected: 'redemptionCodes',*/}
                            {/*                selectedAdmin: '',*/}
                            {/*            })*/}
                            {/*        }*/}
                            {/*    >*/}
                            {/*        REDEMPTION*/}
                            {/*    </NavLink>*/}
                            {/*</NavItem>*/}
                            <NavItem className="main-menu" id="cities">
                                <NavLink
                                    tag={Link}
                                    className="main-menu"
                                    to="/secure/locations"
                                    onClick={() => this.setState({ selected: 'cities', selectedAdmin: '' })}
                                >
                                    CITIES
                                </NavLink>
                            </NavItem>
                            <NavItem className="main-menu" id="branches">
                                <NavLink
                                    tag={Link}
                                    className="main-menu"
                                    to="/secure/branches"
                                    onClick={() => this.setState({ selected: 'branches', selectedAdmin: '' })}
                                >
                                    BRANCHES
                                </NavLink>
                            </NavItem>
                            {this.permission.isAdmin && (
                                <NavItem className="main-menu" id="users">
                                    <NavLink
                                        tag={Link}
                                        className="main-menu"
                                        to="/secure/users"
                                        onClick={() => this.setState({ selected: 'users', selectedAdmin: '' })}
                                    >
                                        USERS
                                    </NavLink>
                                </NavItem>
                            )}
                            {this.permission.isAdmin && (
                                <NavItem className="main-menu" id="clubs">
                                    <NavLink
                                        tag={Link}
                                        className="main-menu"
                                        to="/secure/clubs"
                                        onClick={() => this.setState({ selected: 'clubs', selectedAdmin: '' })}
                                    >
                                        CLUBS
                                    </NavLink>
                                </NavItem>
                            )}
                            {/*
                                this.permission.isAdmin
                                && <NavItem className="main-menu-2 menu-admin-with" id="admin" onClick={() => this.setState({ selected: "admin", toggleAdminDropdown: !toggleAdminDropdown })} >
                                    <NavLink className="main-menu-2">ADMIN &nbsp;&nbsp;&nbsp;&nbsp;
                                        <i className="fa fa-chevron-down fa-xs" id="main-menu-chevron-down"></i>
                                    </NavLink>
                                    {
                                        toggleAdminDropdown ?
                                            <ButtonGroup className="main-menu-admin-group">
                                                <Button tag={Link} id="clubs" to="/secure/clubs" className="main-menu-admin left btn-drop" onClick={() => { this.setState({ selectedAdmin: "clubs" }); }}>CLUBS</Button>
                                                <Button tag={Link} id="users" to="/secure/users" className="main-menu-admin right btn-drop" onClick={() => this.setState({ selectedAdmin: "users" })}>USERS</Button>
                                            </ButtonGroup>
                                            : null
                                    }

                                </NavItem>
                                */}
                        </ul>
                    </Collapse>
                </Container>
            </Navbar>
        )
    }
}

export default connect(
    state => {
        return {
            currentNavigationSelect: state.data.currentNavigationSelect,
        }
    },
    dispatch => ({
        currentNavigationConnect: response => {
            dispatch(updateRedirect(response))
        },
    })
)(Navigation)
